import { render, staticRenderFns } from "./OrganizationMemberChip.vue?vue&type=template&id=3662f65e&scoped=true"
import script from "./OrganizationMemberChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationMemberChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationMemberChip.vue?vue&type=style&index=0&id=3662f65e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662f65e",
  null
  
)

export default component.exports